import { formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

/** The parts of a refusal from Authenticate/token or email-verification/* the sign-in page reads. */
export interface LoginErrorBody {
  success?: boolean;
  passwordResetRequired?: boolean;
  /** A wrong code (email-verification/verify). */
  attemptsLeft?: number;
  /** A 429 from a send: this challenge's limit, or the user's limit for emails or phone codes. */
  limit?: 'challenge' | 'emails' | 'phone';
  /** UTC. With `emails` or `phone`: when another code can be sent. */
  retryAfter?: string | null;
  /** A 410: the challenge was finished, or it ran out. */
  reason?: 'completed' | 'expired' | 'number' | 'unavailable';
}

/** People copy "482 913" as a message shows it. */
export function normaliseCode(code: string): string {
  return code.replace(/\s/g, '');
}

/** The refusal may arrive as a JSON string; anything unreadable (a proxy's HTML page) is no body. */
export function parseErrorBody(error: unknown): LoginErrorBody | null {
  if (typeof error !== 'string') {
    return (error as LoginErrorBody) ?? null;
  }
  try {
    return JSON.parse(error);
  } catch {
    return null;
  }
}

/**
 * When a sign-in limit lifts, in the browser's time zone: the time alone on the same day, with the date
 * otherwise, since the wrong-code limit can last into tomorrow.
 */
export function retryTime(retryAfter: string | null | undefined, locale: string, now = new Date()): string {
  if (!retryAfter) {
    return '';
  }
  const at = new Date(retryAfter);
  return formatDate(at, at.toDateString() === now.toDateString() ? 'shortTime' : 'short', locale);
}

/** A 410 says `completed` once the challenge was finished, from the email link or another tab. */
export function goneReason(response: HttpErrorResponse): 'completed' | 'expired' {
  return parseErrorBody(response.error)?.reason === 'completed' ? 'completed' : 'expired';
}
